import { AxiosPromise } from 'axios';

import { axiosc } from 'src/app/utils';
import { queryTypes, servicesVeritabaniTypes } from 'src/types';
import { urlHelper } from 'src/app/helpers';
import { urlsConfig } from 'src/configs';
import { SistemZaman } from 'src/types/mixed.type';

export const veritabaniLookup = ({
  limit,
  offset,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
}: servicesVeritabaniTypes.VeritabaniLookupDataType): AxiosPromise<servicesVeritabaniTypes.VeritabaniLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (value) {
    query.search = value;
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  if (limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  return axiosc.get(urlHelper.addQueryParameters(query, urlsConfig.generics.common.veritabani), {
    blockSpinner,
  });
};
